import { Box, Divider, InlineStack, Text } from '@shopify/polaris'
import React from 'react'

interface Props {
  label: string
  last?: boolean
  children: any
}

export const DetailsRow = ({ label, last, children }: Props) => {
  return (
    <>
      <Box paddingBlock="100">
        <InlineStack align="space-between">
          <Text as="span" fontWeight="semibold">
            {label}:
          </Text>
          <span children={children} />
        </InlineStack>
      </Box>
      {!last && <Divider />}
    </>
  )
}
